module.exports = __webpack_public_path__ + "img/regiter-icon04-selected.0f7969fb.png";